export default "__VITE_ASSET__C9aw2CC0__"